export const UNKNOWN_ERROR_MESSAGE =
  "Something went wrong. Please try again later.";

export const VALIDATE_EMAIL_ERRORS = {
  BLACKLISTED_DOMAIN: "BLACKLISTED_DOMAIN",
  EMAIL_ERROR: "EMAIL_ERROR",
  SSO_NOT_ENABLED: "SSO_NOT_ENABLED"
};
